<template>
  <div id="show-client-portal-catalogs">
    <v-card class="mt-3">
      <v-card-title>
        Catalogue groupe
        <v-spacer></v-spacer>
        <v-btn
          v-if="isGrantedUser()"
          color="primary"
          icon
          @click.stop="createCatalogDialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-catalog-dialog
          :group="group"
          :partner="group.partner"
          :open.sync="createCatalogDialog"
          v-if="createCatalogDialog && isGrantedUser()"
        ></create-catalog-dialog>
      </v-card-title>
      <v-card-text>
        <catalog-datatable
          :is-loading="isLoading"
          :first-load="firstLoad"
          :catalogs="catalogs"
          :partner="group.partner"
        ></catalog-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs } from "@vue/composition-api";
import CatalogDatatable from "@/components/Catalog/CatalogDatatable";
import { useCatalogs } from "@/composables/catalog";
import CreateCatalogDialog from "@/components/Catalog/CreateCatalogDialog";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    group: Object,
  },
  components: { CreateCatalogDialog, CatalogDatatable },
  setup(props) {
    const { catalogs, listCatalogs, catalogData } = useCatalogs();
    const { isGrantedUser } = useRoles();

    onMounted(() => {
      listCatalogs(null, props.group.id);
    });

    return {
      catalogs,
      ...toRefs(catalogData),
      isGrantedUser,
    };
  },
};
</script>
